let index = 0;

export default function uniqueSuffix(value) {
    const suffix = index++;

    return value ? `${value}_${suffix}` : suffix;
}
